// extracted by mini-css-extract-plugin
module.exports = {"grid":"DrugCard_grid__1wn1J"};